import React, { useState } from 'react';
import CompanyForm from './components/CompanyForm';
import Dashboard from './components/Dashboard';
import axios from 'axios';

function App() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [analysisData, setAnalysisData] = useState(null);

  // Detect if we're in development or production
  const API_BASE_URL = process.env.NODE_ENV === 'development' 
    ? 'http://localhost:5001'  // Changed from 5000 to 5001
    : '';

  const handleAnalyze = async (companyDescription, subreddits) => {
    setLoading(true);
    setError('');
    
    try {
      const response = await axios.post(`${API_BASE_URL}/api/analyze`, {
        company_description: companyDescription,
        subreddits: subreddits,
        top_k: 20
      });
      
      if (response.data.success) {
        setPosts(response.data.posts);
        setAnalysisData({
          company_description: response.data.company_description,
          subreddits: response.data.subreddits,
          total_found: response.data.total_found
        });
      } else {
        setError('Failed to analyze posts');
      }
    } catch (err) {
      setError(err.response?.data?.error || 'An error occurred while analyzing posts');
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    setPosts([]);
    setAnalysisData(null);
    setError('');
  };

  return (
    <div className="min-h-screen bg-gray-900">
      <header className="gradient-bg text-white py-8">
        <div className="max-w-6xl mx-auto px-4">
          <div className="flex items-center justify-center gap-4 mb-4">
            <img 
              src="/logo.png" 
              alt="Company Logo" 
              className="h-12 w-auto"
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
            <h1 className="text-4xl font-bold">Reddit Listener</h1>
          </div>
          <p className="text-xl opacity-90 text-center">Find engagement opportunities for your brand on Reddit</p>
        </div>
      </header>
      
      <div className="max-w-6xl mx-auto px-4 py-8">
        {error && (
          <div className="bg-red-900 border border-red-700 text-red-100 px-4 py-3 rounded mb-4">
            {error}
          </div>
        )}
        
        {!posts.length && !loading && (
          <CompanyForm onAnalyze={handleAnalyze} loading={loading} />
        )}
        
        {loading && (
          <div className="text-center py-8">
            <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-purple-400 mb-4"></div>
            <p className="text-purple-400 text-lg">Analyzing Reddit posts... This may take a few minutes.</p>
          </div>
        )}
        
        {posts.length > 0 && (
          <Dashboard 
            posts={posts} 
            analysisData={analysisData}
            onReset={handleReset}
          />
        )}
      </div>
      
      {/* Reddit Attribution Footer */}
      <footer className="bg-gray-800 text-gray-400 py-6 mt-16">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <p className="text-sm">
            Data sourced from Reddit API. Reddit is a trademark of Reddit, Inc.
          </p>
          <p className="text-xs mt-2 opacity-75">
            This application respects Reddit's Terms of Service and API guidelines.
          </p>
        </div>
      </footer>
    </div>
  );
}

export default App; 